import React from 'react';
import FilteredAutomationList from '../components/FilteredAutomationList';

const NoCompletionStatus = () => {
    const breadcrumbItems = [
        { label: 'Home', href: '/' },
        { label: 'Automation Trigger', href: '/automation' },
        { label: 'Failed Due to Other Reason', active: true }
    ];

    return (
        <FilteredAutomationList
            completionStatus="no_completion_status"
            title="Failed Due to Other Reason"
            subtitle="Automation runs that failed due to other reasons"
            breadcrumbItems={breadcrumbItems}
        />
    );
};

export default NoCompletionStatus;